// extracted by mini-css-extract-plugin
export default {"selects":"DayTeacherClassroomSelector_selects__onmwC"};